module.exports = __webpack_public_path__ + "static/media/mailbox.8c628c66.svg";